function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/*eslint n/no-unsupported-features/es-syntax: ["error", {version: "14.0"}] */
import { createNanoEvents } from 'nanoevents';
import { Hub } from "../hub/index.js";
import { ReasonError, DisconnectedError, SubscriptionRejectedError } from "../protocol/index.js";
import { NoopLogger } from "../logger/index.js";
import { Channel } from "../channel/index.js";
export var NoConnectionError = /*#__PURE__*/function (_ReasonError) {
  _inherits(NoConnectionError, _ReasonError);

  var _super = _createSuper(NoConnectionError);

  function NoConnectionError() {
    var _this;

    _classCallCheck(this, NoConnectionError);

    _this = _super.call(this, 'No connection', 'closed');
    _this.name = 'NoConnectionError';
    return _this;
  }

  return NoConnectionError;
}(ReasonError);
export var GhostChannel = /*#__PURE__*/function (_Channel) {
  _inherits(GhostChannel, _Channel);

  var _super2 = _createSuper(GhostChannel);

  function GhostChannel(channelId, params) {
    var _this2;

    _classCallCheck(this, GhostChannel);

    _this2 = _super2.call(this, params);
    _this2.channelId = channelId;
    return _this2;
  }

  _createClass(GhostChannel, [{
    key: "channelId",
    get: function get() {
      return this._channelId;
    },
    set: function set(val) {
      this._channelId = val;
    }
  }]);

  return GhostChannel;
}(Channel);
GhostChannel.identifier = '__ghost__';
var STATE = Symbol('state');
export var Cable = /*#__PURE__*/function () {
  function Cable(_ref) {
    var transport = _ref.transport,
        protocol = _ref.protocol,
        encoder = _ref.encoder,
        logger = _ref.logger,
        lazy = _ref.lazy;

    _classCallCheck(this, Cable);

    this.emitter = createNanoEvents();
    this.transport = transport;
    this.encoder = encoder;
    this.logger = logger || new NoopLogger();
    this.protocol = protocol;
    this.protocol.attached(this);
    this.hub = new Hub();
    this[STATE] = 'idle';
    this.handleClose = this.handleClose.bind(this);
    this.handleIncoming = this.handleIncoming.bind(this);
    this.transport.on('close', this.handleClose);
    this.transport.on('data', this.handleIncoming);
    this.initialConnect = true;
    this.recovering = false;

    if (lazy === false) {
      this.connect().catch(function () {});
    }
  }

  _createClass(Cable, [{
    key: "state",
    get: function get() {
      return this[STATE];
    }
  }, {
    key: "connect",
    value: function () {
      var _connect = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var promise;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(this.state === 'connected')) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return", Promise.resolve());

              case 2:
                if (!(this.state === 'connecting')) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return", this.pendingConnect());

              case 4:
                this[STATE] = 'connecting';
                promise = this.pendingConnect();
                this.logger.debug('connecting');
                _context.prev = 7;
                _context.next = 10;
                return this.transport.open();

              case 10:
                _context.next = 15;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context["catch"](7);
                this.handleClose(_context.t0);

              case 15:
                return _context.abrupt("return", promise);

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[7, 12]]);
      }));

      function connect() {
        return _connect.apply(this, arguments);
      }

      return connect;
    }()
  }, {
    key: "connected",
    value: function connected() {
      var _this3 = this;

      if (this.state === 'connected') return;
      this.logger.info('connected');
      this[STATE] = 'connected';

      if (this.recovering) {
        // Make sure channels moved to disconnect state
        this.hub.subscriptions.all().forEach(function (subscription) {
          return subscription.notify('disconnected', new DisconnectedError('recovery_failed'));
        });
      } // Re-subscribe channels


      this.hub.subscriptions.all().forEach(function (subscription) {
        return _this3._resubscribe(subscription);
      });
      var restored = false;
      this.recovering = false;

      if (this.initialConnect) {
        this.initialConnect = false;
        this.emit('connect', {
          reconnect: false,
          restored: restored
        });
      } else {
        this.emit('connect', {
          reconnect: true,
          restored: restored
        });
      }
    }
  }, {
    key: "restored",
    value: function restored(remoteIds) {
      var _this4 = this;

      if (!this.recovering) {
        this.connected();
        return;
      }

      this.logger.info('connection recovered', {
        remoteIds: remoteIds
      });
      this[STATE] = 'connected';
      this.hub.subscriptions.all().forEach(function (subscription) {
        if (remoteIds && subscription.remoteId && remoteIds.includes(subscription.remoteId)) {
          subscription.notify('restored');
        } else {
          subscription.notify('disconnected', new DisconnectedError('recovery_failed'));

          _this4._resubscribe(subscription);
        }
      });
      var reconnect = !this.initialConnect;
      var restored = true;
      this.recovering = false;
      this.initialConnect = false;
      this.emit('connect', {
        reconnect: reconnect,
        restored: restored
      });
    }
  }, {
    key: "handleClose",
    value: function handleClose(err) {
      this.logger.debug('transport closed', {
        error: err
      });
      this.disconnected(new DisconnectedError(err, 'transport_closed'));
    }
  }, {
    key: "disconnected",
    value: function disconnected(err) {
      if (!(this.state === 'connected' || this.state === 'connecting')) {
        return;
      }

      this.logger.info('disconnected', {
        reason: err
      });
      this[STATE] = 'disconnected';
      this.recovering = this.protocol.recoverableClosure(err);

      if (this.recovering) {
        this.hub.subscriptions.all().forEach(function (subscription) {
          return subscription.notify('connecting');
        });
      } else {
        this.hub.subscriptions.all().forEach(function (subscription) {
          subscription.notify('disconnected', err);
        });
      }

      this.protocol.reset(err);
      this.hub.close();
      this.transport.close();
      this.emit('disconnect', err);
    }
  }, {
    key: "closed",
    value: function closed(reason) {
      if (this.state === 'closed' || this.state === 'idle') return;
      var err;

      if (reason) {
        err = reason instanceof DisconnectedError ? reason : new DisconnectedError(reason, undefined);
      }

      this.logger.info('closed', {
        reason: reason || 'user'
      });
      this[STATE] = 'closed'; // Channels must transition to the disconnected phase,
      // since they got reconnected as soon as cable reconnects

      var channelErr = err || new DisconnectedError('cable_closed');
      this.hub.subscriptions.all().forEach(function (subscription) {
        return subscription.notify('disconnected', channelErr);
      });
      this.hub.close();
      this.protocol.reset();
      this.transport.close();
      this.initialConnect = true;
      this.emit('close', err);
    }
  }, {
    key: "disconnect",
    value: function disconnect() {
      this.closed();
    }
  }, {
    key: "handleIncoming",
    value: function handleIncoming(raw) {
      if (this.state === 'closed' || this.state === 'idle') {
        return;
      }

      var data = this.encoder.decode(raw);

      if (data === undefined) {
        this.logger.error('failed to decode message', {
          message: raw
        });
        return;
      }

      this.logger.debug('incoming data', data);
      var processed = this.protocol.receive(data);

      if (processed) {
        this.logger.debug('processed incoming message', processed);
        var identifier = processed.identifier,
            message = processed.message,
            meta = processed.meta;
        this.hub.transmit(identifier, message, meta);
      }
    }
  }, {
    key: "send",
    value: function send(msg) {
      if (this.state === 'closed') {
        throw Error('Cable is closed');
      }

      var data = this.encoder.encode(msg);

      if (data === undefined) {
        this.logger.error('failed to encode message', {
          message: msg
        });
        return;
      }

      this.logger.debug('outgoing message', msg);
      this.transport.send(data);
    }
  }, {
    key: "keepalive",
    value: function keepalive(msg) {
      this.emit('keepalive', msg);
    }
  }, {
    key: "subscribeTo",
    value: function subscribeTo(ChannelClass, params) {
      var channel;
      var ghostName;

      if (typeof ChannelClass === 'string') {
        ghostName = ChannelClass;
        ChannelClass = GhostChannel;
      }

      channel = ghostName ? new ChannelClass(ghostName, params) : new ChannelClass(params);
      return this.subscribe(channel);
    }
  }, {
    key: "subscribe",
    value: function subscribe(channel) {
      var _this5 = this;

      // Return if channel has been already attached to the cable
      if (!channel.attached(this)) return channel;
      var identifier = channel.identifier;
      channel.connecting();
      var subscription = this.hub.subscriptions.get(identifier) || this.hub.subscriptions.create(identifier, {
        subscribe: function subscribe(sub) {
          return _this5._subscribe(sub, channel.channelId, channel.params);
        },
        unsubscribe: function unsubscribe(sub) {
          return _this5._unsubscribe(sub);
        }
      });
      subscription.add(channel);

      if (subscription.intent === 'subscribed' && subscription.state === 'connected') {
        channel.connected();
      }

      subscription.ensureSubscribed();
      return channel;
    }
  }, {
    key: "_resubscribe",
    value: function () {
      var _resubscribe2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(subscription) {
        var channel;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(subscription.intent !== 'subscribed')) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                channel = subscription.channels[0];

                if (channel) {
                  _context2.next = 5;
                  break;
                }

                return _context2.abrupt("return");

              case 5:
                subscription.notify('connecting');
                subscription.ensureResubscribed();

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function _resubscribe(_x) {
        return _resubscribe2.apply(this, arguments);
      }

      return _resubscribe;
    }()
  }, {
    key: "_subscribe",
    value: function () {
      var _subscribe2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(subscription, channelId, params) {
        var identifier, lock, channelMeta, remoteId;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                identifier = subscription.id;

                if (this.state === 'idle') {
                  // Trigger connection initialization if it is lazy
                  this.connect().catch(function () {});
                } // We will call _subscribe again as soon as cable connected


                if (!(this.state !== 'connected')) {
                  _context3.next = 5;
                  break;
                }

                this.logger.debug('cancel subscribe, no connection', {
                  identifier: identifier
                });
                return _context3.abrupt("return");

              case 5:
                this.logger.debug('acquiring subscribe lock', {
                  identifier: identifier
                });
                _context3.next = 8;
                return subscription.acquire('subscribed');

              case 8:
                lock = _context3.sent;

                if (!lock.canceled) {
                  _context3.next = 13;
                  break;
                }

                this.logger.debug('subscribe lock has been canceled', {
                  identifier: identifier
                });
                lock.release();
                return _context3.abrupt("return");

              case 13:
                this.logger.debug('subscribe lock has been acquired', {
                  identifier: identifier
                });

                if (!(subscription.intent !== 'subscribed')) {
                  _context3.next = 18;
                  break;
                }

                this.logger.debug('cancel subscribe request, already unsubscribed');
                lock.release();
                return _context3.abrupt("return");

              case 18:
                if (!(this.state !== 'connected')) {
                  _context3.next = 22;
                  break;
                }

                this.logger.debug('cancel subscribe, no connection', {
                  identifier: identifier
                });
                lock.release();
                return _context3.abrupt("return");

              case 22:
                if (!(subscription.state === 'connected')) {
                  _context3.next = 27;
                  break;
                }

                this.logger.debug('already connected, skip subscribe command', {
                  identifier: identifier
                });
                subscription.notify('connected');
                lock.release();
                return _context3.abrupt("return");

              case 27:
                channelMeta = {
                  identifier: channelId,
                  params: params
                };
                this.logger.debug('subscribing', channelMeta);
                _context3.prev = 29;
                _context3.next = 32;
                return this.protocol.subscribe(channelId, params);

              case 32:
                remoteId = _context3.sent;
                this.hub.subscribe(identifier, remoteId);
                this.logger.debug('subscribed', _objectSpread(_objectSpread({}, channelMeta), {}, {
                  remoteId: remoteId
                }));
                subscription.notify('connected');
                _context3.next = 49;
                break;

              case 38:
                _context3.prev = 38;
                _context3.t0 = _context3["catch"](29);

                if (!_context3.t0) {
                  _context3.next = 47;
                  break;
                }

                if (_context3.t0 instanceof SubscriptionRejectedError) {
                  this.logger.warn('rejected', channelMeta);
                }

                if (!(_context3.t0 instanceof DisconnectedError)) {
                  _context3.next = 46;
                  break;
                }

                this.logger.debug('disconnected during subscription; will retry on connect', channelMeta);
                lock.release();
                return _context3.abrupt("return");

              case 46:
                this.logger.error('failed to subscribe', _objectSpread({
                  error: _context3.t0
                }, channelMeta));

              case 47:
                subscription.close(_context3.t0);
                this.hub.unsubscribe(identifier);

              case 49:
                lock.release();

              case 50:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[29, 38]]);
      }));

      function _subscribe(_x2, _x3, _x4) {
        return _subscribe2.apply(this, arguments);
      }

      return _subscribe;
    }()
  }, {
    key: "unsubscribe",
    value: function unsubscribe(channel) {
      var identifier = channel.identifier;
      var subscription = this.hub.subscriptions.get(identifier);

      if (!subscription) {
        throw Error("Subscription not found: ".concat(identifier));
      }

      subscription.remove(channel);
      channel.closed();
      subscription.maybeUnsubscribe();
    }
  }, {
    key: "_unsubscribe",
    value: function () {
      var _unsubscribe2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(subscription) {
        var identifier, lock, remoteId;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                identifier = subscription.id;
                this.logger.debug('acquiring unsubscribe lock', {
                  identifier: identifier
                });
                _context4.next = 4;
                return subscription.acquire('unsubscribed');

              case 4:
                lock = _context4.sent;

                if (!lock.canceled) {
                  _context4.next = 9;
                  break;
                }

                this.logger.debug('unsubscribe lock has been canceled', {
                  identifier: identifier
                });
                lock.release();
                return _context4.abrupt("return");

              case 9:
                this.logger.debug('unsubscribe lock has been acquired', {
                  identifier: identifier
                }); // Check if we still want to unsubscribe

                if (!(subscription.intent !== 'unsubscribed')) {
                  _context4.next = 14;
                  break;
                }

                this.logger.debug('cancel unsubscribe, no longer needed', {
                  identifier: identifier,
                  intent: subscription.intent
                });
                lock.release();
                return _context4.abrupt("return");

              case 14:
                if (!(subscription.state === 'disconnected' || subscription.state === 'closed')) {
                  _context4.next = 18;
                  break;
                }

                this.logger.debug("already ".concat(subscription.state, " connected, skip unsubscribe command"), {
                  identifier: identifier
                });
                lock.release();
                return _context4.abrupt("return");

              case 18:
                remoteId = subscription.remoteId;
                this.logger.debug('unsubscribing...', {
                  remoteId: remoteId
                });

                if (!(this.state !== 'connected')) {
                  _context4.next = 26;
                  break;
                }

                this.logger.debug('unsubscribe skipped (cable is not connected)', {
                  id: identifier
                });
                subscription.close();
                this.hub.unsubscribe(identifier);
                lock.release();
                return _context4.abrupt("return");

              case 26:
                _context4.prev = 26;
                _context4.next = 29;
                return this.protocol.unsubscribe(remoteId);

              case 29:
                this.logger.debug('unsubscribed remotely', {
                  id: identifier
                });
                _context4.next = 35;
                break;

              case 32:
                _context4.prev = 32;
                _context4.t0 = _context4["catch"](26);

                if (_context4.t0) {
                  // We assume that server unsubscribes subscriptions on disconnect,
                  // So we can mark it as closed locally.
                  if (_context4.t0 instanceof DisconnectedError) {
                    this.logger.debug('cable disconnected during the unsubscribe command execution', {
                      id: identifier,
                      error: _context4.t0
                    });
                  } else {
                    this.logger.error('unsubscribe failed', {
                      id: identifier,
                      error: _context4.t0
                    });
                  }
                }

              case 35:
                if (subscription.intent === 'unsubscribed') {
                  subscription.close();
                  this.hub.unsubscribe(identifier);
                } else {
                  // We rely on state when performing commands,
                  // make sure it's set to closed here (it shouldn't stay connected)
                  subscription.state = 'closed';
                }

                lock.release();

              case 37:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[26, 32]]);
      }));

      function _unsubscribe(_x5) {
        return _unsubscribe2.apply(this, arguments);
      }

      return _unsubscribe;
    }()
  }, {
    key: "perform",
    value: function () {
      var _perform = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(identifier, action, payload) {
        var subscription, remoteId, performMeta, res;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!(this.state === 'connecting')) {
                  _context5.next = 3;
                  break;
                }

                _context5.next = 3;
                return this.pendingConnect();

              case 3:
                if (!(this.state === 'closed' || this.state === 'disconnected')) {
                  _context5.next = 5;
                  break;
                }

                throw new NoConnectionError();

              case 5:
                subscription = this.hub.subscriptions.get(identifier);

                if (subscription) {
                  _context5.next = 8;
                  break;
                }

                throw Error("Subscription not found: ".concat(identifier));

              case 8:
                _context5.next = 10;
                return subscription.pending('subscribed');

              case 10:
                if (!(subscription.intent !== 'subscribed')) {
                  _context5.next = 12;
                  break;
                }

                throw Error("Subscription is closed: ".concat(identifier));

              case 12:
                remoteId = subscription.remoteId;
                performMeta = {
                  id: remoteId,
                  action: action,
                  payload: payload
                };
                this.logger.debug('perform', performMeta);
                _context5.prev = 15;
                _context5.next = 18;
                return this.protocol.perform(remoteId, action, payload);

              case 18:
                res = _context5.sent;

                if (res) {
                  this.logger.debug('perform result', {
                    message: res,
                    request: performMeta
                  });
                }

                return _context5.abrupt("return", res);

              case 23:
                _context5.prev = 23;
                _context5.t0 = _context5["catch"](15);
                this.logger.error('perform failed', {
                  error: _context5.t0,
                  request: performMeta
                });
                throw _context5.t0;

              case 27:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[15, 23]]);
      }));

      function perform(_x6, _x7, _x8) {
        return _perform.apply(this, arguments);
      }

      return perform;
    }()
  }, {
    key: "on",
    value: function on(event, callback) {
      return this.emitter.on(event, callback);
    }
  }, {
    key: "once",
    value: function once(event, callback) {
      var unbind = this.emitter.on(event, function () {
        unbind();
        callback.apply(void 0, arguments);
      });
      return unbind;
    }
  }, {
    key: "emit",
    value: function emit(event) {
      var _this$emitter;

      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return (_this$emitter = this.emitter).emit.apply(_this$emitter, [event].concat(args));
    }
  }, {
    key: "pendingConnect",
    value: function pendingConnect() {
      var _this6 = this;

      if (this._pendingConnect) return this._pendingConnect;
      this._pendingConnect = new Promise(function (resolve, reject) {
        var unbind = [function () {
          return delete _this6._pendingConnect;
        }];
        unbind.push(_this6.on('connect', function () {
          unbind.forEach(function (clbk) {
            return clbk();
          });
          resolve();
        }));
        unbind.push(_this6.on('close', function (err) {
          unbind.forEach(function (clbk) {
            return clbk();
          });
          reject(err);
        }));
        unbind.push(_this6.on('disconnect', function (err) {
          unbind.forEach(function (clbk) {
            return clbk();
          });
          reject(err);
        }));
      });
      return this._pendingConnect;
    }
  }]);

  return Cable;
}();